import controller from './folder-details.controller';

const template = require('./folder-details.html');

export default {
    bindings: {
        folder: '<',
        onSaved: '&',
        onEditCancelled: '&',
        onDeleted: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-details/folder-details.component.js